import validate from '../../lib/form/validators'
import {createSecondaryAuthAccess} from '../../lib/api/login'
import * as loadingActions from './loading'
import getDeviceInfo from '../../lib/shim/deviceInfo'
import {enablePinUI} from './auth'

export const VALIDATE_STEP	= 'CREATE_PIN_VALIDATE_FORM_STEP'
export const PREVIOUS_STEP	= 'CREATE_PIN_PREVIOUS_STEP'
export const NEXT_STEP		= 'CREATE_PIN_NEXT_STEP'
export const RESET_STATE	= 'CREATE_PIN_RESET_STATE'
export const SUBMIT_PIN 	= 'CREATE_PIN_SUBMIT'
export const STORE_PIN 		= 'CREATE_PIN_STORE'

/**
 * Store the pin as the user is writing it
 * @param pin
 * @param page
 * @return {{type: string, pin: *, page: *}}
 */
export function storePin(pin, page){
	return (dispatch) => {
		const validation = validate.single(pin, {
			presence: {
				message: '^A PIN is required.'
			},
			length: {
				minimum: 4,
				maximum: 10,
				tooShort: "^PIN needs to have %{count} digits or more",
				tooLong: "^PIN needs to be under %{count} digits"
			},
			format: {
				pattern: '^[0-9]+$',
				message: "^PIN can only contain numbers"
			}
		})

		dispatch(_setStorePin(pin, page, validation))

		if(typeof(validation) !== 'undefined'){
			return Promise.reject(new Error('Failed Validation'))
		}

		return Promise.resolve()
	}
}

function _setStorePin(pin, page, validation){
	return {
		type: STORE_PIN,
		pin: pin,
		page: page,
		validation: validation ? validation.shift() : undefined
	}
}

export function nextStep(){
	return {
		type: NEXT_STEP,
	}
}

export function previousStep(){
	return {
		type: PREVIOUS_STEP
	}
}

export function resetState(){
	return {
		type: RESET_STATE
	}
}

/**
 * Create the pin
 * @param pin
 * @return {function(*=)}
 */
export function submitPin(pin){
	return (dispatch) => {
		return loadingActions.promise(
			dispatch,
			SUBMIT_PIN,
			createSecondaryAuthAccess(pin, getDeviceInfo().getUniqueID(), 'pin')
		).then(() => dispatch(enablePinUI()))
	}
}




// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/actions/create-pin.js